import accountSlice from './slice'

// eslint-disable-next-line import/prefer-default-export
export const accountActions = accountSlice.actions
